<div class="contents-area">
  <div class="column-list">
    <label class="list-input-title">出力区分</label>
    <div class="list-input-content">
      <app-radio-label label="バイヤー・編集" groupName="rbtg_radiogroup" id="rbtn_Buyer" #rbtn_Buyer [subid]="'rbtn_Buyer'"
        [value]="KYMW6700Model.OUTPUT_DIV_BUYER" [forcedEnabledMode]="'true'" [tabindex]="0"
        [(ngModel)]="KYMW6700Model.outputDiv" (change)="eventOutputDivHandler(null)">
      </app-radio-label>
      <app-radio-label label="見切り品" groupName="rbtg_radiogroup" id="rbtn_Logistics" [subid]="'rbtn_Logistics'"
        [value]="KYMW6700Model.OUTPUT_DIV_LOGISTICS" [forcedEnabledMode]="'true'" [tabindex]="0"
        [(ngModel)]="KYMW6700Model.outputDiv" (change)="eventOutputDivHandler(null)">
      </app-radio-label>
    </div>

    <label class="list-input-title">受注コード</label>
    <div class="list-input-content">
      <div class="element-row">
        <app-catalog-progress-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
          [catalogIDField]="txti_CatalogId" [progressWorkNumNameField]="txti_Phase" mediumType="001" [autofocus]="true"
          [forcedEnabledMode]="true" [tabindex]="0" [required]="true" [(ngModel)]="KYMW6700Model.orderCode">
        </app-catalog-progress-text-input>
        <input type="text" id="txti_CatalogId" #txti_CatalogId readonly class="deliv-catalog"/>
        <input style="width:27rem" type="text" id='txti_Phase' #txti_Phase readonly/>
      </div>
    </div>

    <label class="list-input-title">媒体</label>
    <div class="list-input-content">
      <app-plan-medium-type-combo-box id="cmb_MediumType" [subid]="'cmb_MediumType'" [blank]="false"
        [forcedEnabledMode]="'true'" [tabindex]="0" [required]="true" [disabled]="KYMW6700Model.disabledMediumToFlg"
        [(ngModel)]="KYMW6700Model.mediumType" [initFocusItem]="txti_OrderCode" style="width: 100%;">
      </app-plan-medium-type-combo-box>
    </div>

    <label class="list-input-title">フェーズ</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_Phase" [codeDiv]="'ctp004'" [conReserveNum1]="'1'"
        [latestInfo]="true" [blank]="false" [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0"
        [required]="true" [disabled]="KYMW6700Model.disabledPhaseToFlg" [(ngModel)]="KYMW6700Model.progressWorkNum"
        [initFocusItem]="txti_OrderCode">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">部門</label>
    <div class="list-input-content">
      <app-class-code-combo-box id="cmb_ClassCode" [blank]="true" [forcedEnabledMode]="'true'"
        [tabindex]="0" [(ngModel)]="KYMW6700Model.classCode" [initFocusItem]="txti_OrderCode">
      </app-class-code-combo-box>
    </div>

    <label class="list-input-title">バイヤーコード</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_BuyerCode" [codeDiv]="'ct357'" [labelField]="'codeValueName'"
        [blank]="true" [forcedEnabledMode]="'true'" [tabindex]="0" [disabled]="KYMW6700Model.disabledBuyerToFlg"
        [(ngModel)]="KYMW6700Model.buyerCode" [initFocusItem]="txti_OrderCode">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">Ｐコードリスト</label>
    <div class="list-input-content" style="height:560px;">
      <div class="block-row">
        <textarea style="height:560px; max-width:110px;" id="txta_PCodeList" #txta_PCodeList forcedEnabledMode="true" plessInputTextSub
          [restrict]="'[P0-9\n]'" [tabindex]="0" [(ngModel)]="KYMW6700Model.pCodeList">
        </textarea>
        <div class="element-column">
          <label>・１行１件のＰコードを入力してください。</label>
          <label>・一度に入力できるＰコードは最大100件までとします。</label>
        </div>
      </div>
    </div>

    <label class="list-input-title">ソートキー</label>
    <div class="list-input-content">
      <div class="element-row">
        <app-code-combo-box id="cmb_SortDiv1" #cmb_SortDiv1 [codeDiv]="'ctp075'" [initFocusItem]="txti_OrderCode"
          [blank]="true" [forcedEnabledMode]="'true'" [tabindex]="0" class="cmb-sort">
        </app-code-combo-box>
        <app-code-combo-box id="cmb_SortDiv2" #cmb_SortDiv2 [codeDiv]="'ctp075'" [initFocusItem]="txti_OrderCode"
          [blank]="true" [forcedEnabledMode]="'true'" [tabindex]="0" class="cmb-sort">
        </app-code-combo-box>
        <app-code-combo-box id="cmb_SortDiv3" #cmb_SortDiv3 [codeDiv]="'ctp075'" [initFocusItem]="txti_OrderCode"
          [blank]="true" [forcedEnabledMode]="'true'" [tabindex]="0" class="cmb-sort">
        </app-code-combo-box>
      </div>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-primary" id="btn_Output" forcedEnabledMode="true" [tabindex]="0"
    (click)='eventListOut_CLICKHandler()'>出力</button>
</footer>